import PageContainer from 'components/shared/containers/PageContainer';
import  { CenterContentContainer } from 'components/shared/containers/PageLayoutContainer';
import ContentHeaderView from 'components/shared/views/ContentHeaderView';
import PageContentView from 'components/shared/views/PageContentView';
import React from 'react';
import ExternalIframe from 'components/shared/containers/ExternalIframe';
import { useModel, Branding } from "bcms-react";
import "./styles.css";
/**
 * @function ORIGPage
 * @return {React.Component}
 * @note - Branding for this page is being added to the window object so captures can utilize the set value in state code
 * @exported true
 * @description The main component for ORIGPage
 */
export default function ORIGPage(props) {
  // Branding options needed for captures
  //const branding = useModel().branding.options;
  //const label = branding.payments_label_abi22 ?? "Payments";
  //window.BRANDING = { "rxpmw_courseid_abi22" : branding.rxpmw_courseid_abi22 };

  return (
  <>
    {/* iFrame for ORIG19/20 goes here */}
    <Branding id="orig_version_abi22" exp={ value => value === "ORIG19" }>
      <ExternalIframe demo="ORIG19" className="orig19-iframe orig-iframe" page={ props.page } key ="ORIG19Page"/>   
    </Branding>
    <Branding id="orig_version_abi22" exp={ value => value === "ORIG20" || value === "undefined" }>
      <ExternalIframe demo="ORIG20" className="orig20-iframe orig-iframe" page={ props.page } key ="ORIG20Page"/>
    </Branding>  
  </>
  );
}
